/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
  BuilderNavigationService,
  EDoc,
  EDocDetailsDialogConfig,
  edocDetailsDialogRoute,
} from '@gh/builder-shared';
import { EDocSigningStatus } from '@gh/builder-shared-data';
import { dictionaryValueFormatter } from '@gh/common-internal-shared';
import { DateTimeTypes, getInheritedRouteParam, getRouteInitData } from '@gh/common-shared';
import { DialogService } from '@gh/core-ui';
import {
  buildDateTimeColumn,
  GridDefinitionFactory,
  LayoutBasedGridDefinition,
} from '@gh/core-ui-grid';

import { sortBy, values } from 'lodash';

@Component({
  standalone: false,
  selector: 'gh-rfq-e-doc-list-tab',
  templateUrl: 'rfq-e-doc-list-tab.component.html',
})
export class RfqEDocListTabComponent implements OnInit {
  gridDefinition: LayoutBasedGridDefinition;
  log: EDoc[];

  constructor(private route: ActivatedRoute,
              private gridDefinitionFactory: GridDefinitionFactory,
              private navigationService: BuilderNavigationService,
              private dialogs: DialogService) {
  }

  ngOnInit(): void {
    const { gridLayout, signingStatusDict, log } = getRouteInitData(this.route);

    this.log = log;

    this.gridDefinition = this.gridDefinitionFactory.buildLayoutBased(
      {
        addedDate: buildDateTimeColumn(DateTimeTypes.DateTime),
        files: {
          sortable: false,
          valueFormatter: ({ value }) => sortBy(values(value)).join(', '),
        },
        status: {
          valueFormatter: dictionaryValueFormatter(signingStatusDict),
          cellClass: ({ data }: { data: any }) => ({
            [EDocSigningStatus.New]: 'new-status',
            [EDocSigningStatus.Sent]: 'import-status',
            [EDocSigningStatus.Signed]: 'cell--positive',
            [EDocSigningStatus.Cancelled]: 'cell--important',
            [EDocSigningStatus.Failed]: 'cell--negative',
          }[data.status] || ''),
        },
      },
      {
        getRowId: (params) => String(params.data.id)
      });
    this.gridDefinition.bind(gridLayout);
  }

  goToRfqAel(): void {
    this.navigationService.goToAel({
      label: 'lbl_e_docs_signing',
      entityType: 'SALES_FOLDER',
      entityId: getInheritedRouteParam(this.route, 'salesFolderId'),
    });
  }

  onOpen(document: EDoc): void {
    this.dialogs.openWithInput(edocDetailsDialogRoute, <EDocDetailsDialogConfig>{
      documentId: document.id,
    });
  }
}
